import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { clearError } from "../features/web/web-slice";

interface LocationState {
	message?: string;
}

function ErrorPage() {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const storeError = useAppSelector((state) => state.web.error);
	const locationState = (location.state as LocationState) ?? {};
	const errorMessage =
		locationState.message ?? storeError ?? "We could not process your request.";

	useEffect(() => {
		return () => {
			dispatch(clearError());
		};
	}, [dispatch]);

	const handleRetry = () => {
		dispatch(clearError());
		navigate("/dashboard");
	};

	return (
		<section className="page page--error">
			<div className="panel error-panel">
				<p className="eyebrow">Algo no salió bien</p>
				<h1>{errorMessage}</h1>
				<button className="button button--primary" onClick={handleRetry}>
					Intentar de nuevo
				</button>
			</div>
		</section>
	);
}

export default ErrorPage;
